const PrivacyPolicy = () => {
    return (
      <div className="bg-gray-100 dark:bg-gray-900">
        <div className="container mx-auto px-4 py-8 lg:px-32 xl:px-48 dark:text-gray-400">
          <h1 className="text-3xl font-bold mb-4 dark:text-gray-200 text-center">Privacy Policy</h1>
  
          <br />
          <p className="mb-4 font-semibold">
          Decodiefy Technologies respects and values the ‘Right to Privacy’ of individuals. We are esteemed by the relationship and by becoming our clients you have a promise from our side that we shall remain loyal to all our clients and non-clients whose information resides with us. This Privacy Policy of Decodiefy Technologies applies to the current clients as well as former clients. Below are the word by word credentials of our Privacy Policy:
          </p>
  
          <p className="mb-4">
          This Privacy Policy applies just to our online exercises and is legitimate for guests to our site with respect to the data that they shared as well as gather in https://decodiefy.com. This plan isn’t material to any information collected removed or by methods for channels other than this site.
          </p>
        
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Consent</h2>
  
          <p className="mb-4">
          By utilizing our site, you agree to our Privacy Policy and consent to its terms.
          </p>


          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Information we collect</h2>
  
          <p className="mb-4">
          The personal data that you are approached to give, and the reasons why you are approached to give it, will be clarified to you at the point we request that you give your own data.
          </p>

          <p className="mb-4">
          In the event that you get in touch with us legitimately, we may get extra data about you, for example, your name, email address, telephone number, the substance of the message as well as connections you may send us, and some other data you may decide to give.
          </p>

          <p className="mb-4">
          At the point when you register for an Account, we may request your   <b>Personal Information</b> <i>(name, email address, phone number, organisation name)</i>, <b>Billing Information</b> <i>(trading preferences)</i>, <b>Technical Information</b> <i>(IP address, browser type)</i>, <b>Device Information</b> <i>(login activity, Cookies and Usage Data, Financial & Trading Data, Broker Connection Details, encrypted API Keys, Trading Activity through our software, Account Configuration Settings)</i>.
          </p>
  
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">How we use your information</h2>
          <p>We use your information for the following purposes:</p>
          <ul className="list-disc list-inside mb-4">
            <li>
                To provide and maintain our algo trading software services
            </li>
            <li>
                To improve platform performance and user experience
            </li>
            <li>
                To process payments and subscriptions
            </li>
            <li>
                To provide customer support
            </li>
            <li>
                To send important updates, notifications, and promotional offers
            </li>
            <li>
                To maintain platform security and prevent fraud
            </li>
            <li>
                To comply with legal and regulatory requirements
            </li>
          </ul>
  
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Data Security</h2>
  
          <p className="mb-2">
          We implement appropriate security measures to protect your personal information from unauthorized access, misuse, disclosure, or alteration.
          </p>

          <p>These measures include:</p>

          <ul className="list-disc list-inside mb-4">
            <li>Secure servers</li>
            <li>Data encryption</li>
            <li>Firewall protection</li>
            <li>Restricted access controls</li>
            <li>Regular system monitoring</li>
          </ul>

          <p className="mb-4">However, no online platform can guarantee 100% security.</p>

          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Sharing of Information</h2>
  
          <p className="mb-2">
          We do not sell, rent, or trade your personal information to third parties.
          </p>
          
          <p className="mb-2">
          We may share information with:
          </p>
  
          <ul className="list-disc list-inside mb-4">
            <li>Payment gateway providers</li>
            <li>Technology and hosting partners</li>
            <li>Legal authorities when required by law</li>
            <li>Compliance and regulatory agencies</li>
          </ul>

          <p className="mb-4">All third-party partners are required to maintain confidentiality and data security.</p>

          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Cookies Policy</h2>
  
          <p className="mb-2">Our website may use cookies and similar tracking technologies to improve user experience and analyze website traffic.</p>
          
          <p className="mb-4">Users can disable cookies through browser settings, although some features may not function properly.</p>
          
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Third-Party Services</h2>
  
          <p className="mb-2">Our services may contain links or integrations with third-party brokers, trading platforms, or external websites.</p>
          
          <p className="mb-4">We are not responsible for the privacy practices or content of third-party services.</p>
          
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">User Responsibilities</h2>
  
          <p>Users are responsible for:</p>

          <ul className="list-disc list-inside mb-4">
            <li>Maintaining confidentiality of login credentials</li>
            <li>Securing broker API access</li>
            <li>Using the software in compliance with financial regulations</li>
            <li>Ensuring lawful trading activities</li>
          </ul>
          
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">No Financial Advice</h2>
          
          <p className="mb-2">Decodiefy Technologies provides technology and software solutions only.</p>
          
          <p>We do not provide:</p>

          <ul className="list-disc list-inside mb-2">
            <li>Investment advice</li>
            <li>Financial advisory services</li>
            <li>Guaranteed profit assurance</li>
            <li>Portfolio management services</li>
          </ul>

          <p className="mb-4">Trading in financial markets involves risk, and users are solely responsible for their trading decisions.</p>
          
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Data Retention</h2>
          
          <p>We retain user information only for as long as necessary to:</p>

          <ul className="list-disc list-inside mb-2">
            <li>Provide services</li>
            <li>Meet legal obligations</li>
            <li>Resolve disputes</li>
            <li>Enforce agreements</li>
          </ul>

          <p className="mb-4">Users may request account deletion subject to legal and compliance requirements.</p>
          
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Your Rights</h2>
          
          <p>Depending on applicable laws, users may have the right to:</p>

          <ul className="list-disc list-inside mb-2">
            <li>Access their personal data</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of data</li>
            <li>Withdraw consent for marketing communications</li>
          </ul>

          <p className="mb-4">To exercise these rights, users may contact us directly.</p>

          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Changes to This Privacy Policy</h2>
  
          <p className="mb-2">
          We reserve the right to update or modify this Privacy Policy at any time without prior notice.
          </p>
          <p className="mb-2">
            Updated versions will be posted on our official website with the revised effective date.
          </p>
  
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">GDPR Data Protection Rights</h2>
  
          <p className="mb-4">
          We might want to ensure you are completely aware of the entirety of your information security rights. Each client is qualified for the following:
          </p>
  
          <ul className="list-disc list-inside mb-4">
          <li><span className="font-semibold">The right to get to –</span>You reserve the option to demand duplicates of your own information. We may charge you a little expense for this service.</li>
          <li><span className="font-semibold">The right to amendment – </span>You reserve the option to demand that we right any data you accept is mistaken. You additionally reserve the right to demand that we complete the data you accept is incomplete.</li>
          <li><span className="font-semibold">The right to eradication – </span>You reserve the option to demand that we delete your own information, under specific conditions.</li>
          <li><span className="font-semibold">The right to confine processing – </span>You reserve the option to demand that we confine the handling of your own information, under specific conditions.</li>
          <li><span className="font-semibold">The right to protest processing – </span>You reserve the option to question our preparing of your own information, under specific conditions.</li>
          <li><span className="font-semibold">The right to information portability – </span>You reserve the option to demand that we move the data that we have gathered to another association, or directly to you, under specific conditions.</li>
        
          </ul>
  
          <p className="mb-4">
          If you make a request, we have one month to react to you. On the off chance that you might want to practice any of these rights, feel free to get in touch with us.
          </p>
  
          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Children’s Information</h2>
  
          <p className="mb-4">
          Another part of our priority is including security for kids while utilizing the web. We urge parents and guardians to watch, take part in, as well as screen and guide theifr online movement.
          </p>

          <p className="mb-4">
            https://decodiefy.com doesn’t intentionally gather any Personal Identifiable Information from kids younger than 13. If you believe that your kid gave this sort of data on our site, we urge you to get in touch with us quickly and we will do our best attempts to promptly expel such data from our records.
          </p>

          <h2 className="text-2xl font-bold mb-2 dark:text-gray-300">Disclaimer
          </h2>

          <p className="mb-4">
            Algorithmic trading and stock market investments are subject to market risks. Past performance does not guarantee future results. Users should trade responsibly and consult licensed financial advisors where necessary.
          </p>
        </div>
      </div>
    );
  }
  
  export default PrivacyPolicy;
  